import type { FC } from "react";
import { motion, type MotionProps } from "motion/react";
import type { ClassNameProp } from "@huub-web/ui";
import { mergeClasses } from "@huub-web/utils";

export type HouseGraphicProps = ClassNameProp & MotionProps;

export const HouseGraphic: FC<HouseGraphicProps> = ({
  className,
  ...props
}) => (
  <motion.svg
    viewBox="0 0 1440 1440"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={mergeClasses(className)}
    {...props}
  >
    <path
      d="m 1404.3242,815.54343 c 0.3701,-110.03226 -2.8087,-173.7054 -6.5474,-210.53346 -4.9248,-48.52138 -14.2145,-84.95992 -18.2474,-101.58185 -10.8554,-44.68758 -32.9743,-85.61416 -66.537,-117.4132 -7.2591,-6.86518 -20.6102,-19.80346 -49.229,-43.63056 -22.9635,-19.13702 -66.148,-53.29967 -147.1937,-114.2693 C 995.85032,137.24543 922.77252,92.91051 887.27029,73.346337 869.26582,63.438035 845.6837,49.644883 837.74993,45.243819 801.61764,25.214488 761.4136,15.192732 721.20956,15.192732 c -40.20403,0 -80.4204,10.021756 -116.54037,30.038797 -7.93377,4.401063 -31.52822,18.194215 -49.52035,28.101572 -35.50223,19.552829 -108.59332,63.900039 -229.30411,154.769389 -81.0372,60.96962 -124.22743,95.13218 -147.19181,114.26929 -28.61699,23.83968 -41.96899,36.76538 -49.22515,43.63057 -33.565044,31.79837 -55.678545,72.73819 -66.537781,117.41253 -4.035207,16.62288 -13.327331,53.06142 -18.251014,101.5828 -3.75139,36.84035 -6.922797,100.50119 -6.552594,210.54575 H 38 c 0.505944,150.3301 6.453873,243.26207 11.241834,294.23587 3.331785,35.495 7.897618,83.5011 11.278841,99.1436 17.609347,81.4409 78.656015,147.1023 158.199645,172.6105 23.19971,7.4407 78.33567,20.885 142.50423,29.8289 57.2207,7.9702 167.91108,15.5527 358.82545,15.7229 0.39475,0 0.77716,0 1.15956,0 0.39475,0 0.77715,0 1.15956,0 190.91437,-0.1702 301.61618,-7.7716 358.82548,-15.7418 64.1647,-8.9345 119.296,-22.3787 142.5061,-29.8194 79.5465,-25.5177 140.5894,-91.1885 158.201,-172.6144 3.3781,-15.6415 7.9423,-63.6476 11.2729,-99.1426 4.792,-50.9738 10.7226,-143.90576 11.2445,-294.23586 h -0.085 z"
      fill="url(#houseGraphicGradient)"
      fillOpacity="0.06"
      style={{ fill: "url(#houseGraphicGradient)", strokeWidth: "0.947174" }}
    />
    <defs>
      <radialGradient
        id="houseGraphicGradient"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0,705.94765,-683.20956,0,721.20956,721.14038)"
      >
        <stop offset="0.793269" stopColor="white" stopOpacity="0" id="stop1" />
        <stop offset="1" stopColor="white" id="stop2" />
      </radialGradient>
    </defs>
  </motion.svg>
);
